import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { OperationalTrainInfo } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/OperationalTrainInfo";
import TrainReasonCodes from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/TrainReasonCodes/TrainReasonCodes";
import VehicleAlerts from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/VehicleAlerts";

const TrainCondition = () => (
  <>
    <OperationalTrainInfo />
    <VehicleAlerts />
    <TrainReasonCodes />
  </>
);

export default withErrorBoundary(TrainCondition);
